import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Target, Network, Sparkles, Award } from 'lucide-react';
import { whyRegenr8Content } from '../mock';

const WhyRegenr8 = () => {
  const icons = [Award, Network, Sparkles, Target];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl sm:text-5xl font-bold mb-6">{whyRegenr8Content.headline}</h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            Discover the advantages that make us the preferred partner for international expansion
          </p>
        </div>
      </section>

      {/* Reasons Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {whyRegenr8Content.reasons.map((reason, index) => {
              const Icon = icons[index];
              
              return (
                <Card key={index} className="border-2 hover:border-blue-900 transition-all duration-300 hover:shadow-xl group">
                  <CardContent className="p-8">
                    <div className="flex items-start space-x-4">
                      <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-blue-900 transition-colors duration-300">
                        <Icon className="text-blue-900 group-hover:text-white transition-colors duration-300" size={28} />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl font-bold text-gray-900 mb-3">
                          {reason.title}
                        </h3>
                        <p className="text-gray-600 leading-relaxed">
                          {reason.description}
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="p-8">
              <div className="text-5xl font-bold text-blue-900 mb-2">Global</div>
              <p className="text-gray-600 text-lg">Market Reach</p>
            </div>
            <div className="p-8">
              <div className="text-5xl font-bold text-blue-900 mb-2">Strategic</div>
              <p className="text-gray-600 text-lg">Partnership Approach</p>
            </div>
            <div className="p-8">
              <div className="text-5xl font-bold text-blue-900 mb-2">Proven</div>
              <p className="text-gray-600 text-lg">Track Record</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-blue-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">
            Experience the Regenr8 Advantage
          </h2>
          <p className="text-xl text-blue-100 leading-relaxed">
            Join the brands and manufacturers who have successfully expanded their global presence with our guidance. Let's explore how we can accelerate your international growth.
          </p>
        </div>
      </section>
    </div>
  );
};

export default WhyRegenr8;
